/** @format */

/**
 * 表单项验证触发方式
 */
type FormItemTriggerType = 'blur' | 'change';

/**
 * 验证规则
 */
export interface IValidationRule {
  required?: boolean;
  message?: string;
  trigger?: FormItemTriggerType;
  validator?: (rule: IValidationRule, value: any, callback: Function) => void;
  [index: string]: any;
}

/**
 * 自定义提示语
 * @param tip
 */
export const defineTipTrim = (tip: string) => {
  return function(rule: IValidationRule, value: any, callback: Function): void {
    if (!value) {
      callback();
      return;
    }
    let trimLength = 0;

    if (!String.prototype.trim) {
      trimLength = String(value).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '').length;
    } else {
      trimLength = String(value).trim().length;
    }

    // 字符串不能有空格
    if (rule.all) {
      if (!/^\S*$/.test(value)) {
        callback(new Error('不能包含空格'));
      } else {
        callback();
      }
      return;
    }
    if (typeof value === 'string' && !(trimLength === value.length)) {
      const message = trimLength ? '前后不能包含空格' : tip;
      callback(new Error(message));
    } else {
      callback();
    }
  };
};

export const trim = function(rule: IValidationRule, value: any, callback: Function): void {
  if (!value) {
    callback();
    return;
  }
  let trimLength = 0;

  if (!String.prototype.trim) {
    trimLength = String(value).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '').length;
  } else {
    trimLength = String(value).trim().length;
  }

  // 字符串不能有空格
  if (rule.all) {
    if (!/^\S*$/.test(value)) {
      callback(new Error('不能包含空格'));
    } else {
      callback();
    }
    return;
  }
  if (typeof value === 'string' && !(trimLength === value.length)) {
    const message = trimLength ? '前后不能包含空格' : '不能输入纯空格';
    callback(new Error(message));
  } else {
    callback();
  }
};

// 新能源和非新能源车牌
// export const carPlateReg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-HJ-NP-Z]{1}(([0-9]{5}[DFG])|([DFG]([A-HJ-NP-Z0-9])[0-9]{4})))$|^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/
export const carPlateReg = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领临民]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,7}$)|(^[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9\u4e00-\u9fa5]{6,8}$)/;
export const carPlateValidate = function(rule: IValidationRule, value: string, callback: Function) {
  if (!carPlateReg.test(value)) {
    callback(new Error('请输入正确的车牌号码'));
  } else {
    callback();
  }
};

const chineseStr = /^(?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])+$/;
export const chineseStrValidate = function(rule: IValidationRule, value: string, callback: Function) {
  if (!chineseStr.test(value)) {
    callback(new Error('只能输入中文字符'));
  } else {
    callback();
  }
};

export const onlyFloat = function(rule: IValidationRule, value: string, callback: Function) {
  try {
    if (isNaN(+value) || /(^0{2,}|^\.|\.$)/g.test(value)) {
      callback(new Error('只能输入数字'));
    } else {
      callback();
    }
  } catch (error) {
    // if(error)
    callback(new Error('只能输入数字'));
  }
};

export const onlyToFixed2 = function(rule: IValidationRule, value: string, callback: Function) {
  try {
    if (/\.[0-9]{3,}$/g.test(value)) {
      callback(new Error('只能输入数字'));
    } else {
      callback();
    }
  } catch (error) {
    if (error) callback(new Error('只能输入数字'));
  }
};

export function verifyIdCard(rule: IValidationRule, value: string, callback: Function) {
  const document = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (value && !document.test(value)) {
    callback(new Error('请输入正确的证件号码'));
  } else {
    callback();
  }
}
